import script from "./sf-table-row-collapsible-group.vue?vue&type=script&setup=true&lang=ts&generic=TR%20extends%20GroupingTableRow"
export * from "./sf-table-row-collapsible-group.vue?vue&type=script&setup=true&lang=ts&generic=TR%20extends%20GroupingTableRow"

const __exports__ = script;

export default __exports__